import type { Location } from '../types';

/**
 * Strip HTML tags from a string
 */
function stripHtml(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
}

/**
 * Export locations to CSV format
 */
export function exportLocationsToCSV(locations: Location[], filename?: string): void {
  const headers = [
    'Name',
    'Room Number',
    'Site',
    'Account',
    'Phone',
    'Extension',
    'Fax',
    'Tags',
    'Description',
    'Disabled',
    'Created At',
  ];

  const rows = locations.map((location) => [
    location.name || '',
    location.roomNumber || '',
    location.siteName || '',
    location.accountName || '',
    location.phone || '',
    location.extension || '',
    location.fax || '',
    (location.tags || []).join('; '),
    stripHtml(location.description || '').replace(/[\n\r]+/g, ' '),
    location.disabled ? 'Yes' : 'No',
    location.createdAt ? new Date(location.createdAt).toLocaleDateString() : '',
  ]);

  // Escape CSV values
  const escapeCSV = (value: string): string => {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...rows.map((row) => row.map(escapeCSV).join(',')),
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename || `locations-export-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
